export default "__VITE_ASSET__WWSmhEmm__"